import { addMobileConsoleExportPlugin, captureMobileConsoleLogs, createMobileConsoleLogBuffer } from "@/debug/mobileConsolePlugin";

export function isMobileConsoleEnabled(search: string): boolean {
  const value = new URLSearchParams(search).get("debug")?.toLowerCase();
  return value === "1" || value === "true";
}

let installPromise: Promise<void> | null = null;
let stopLogCapture: (() => void) | null = null;

export function resolveMobileConsoleTarget(documentLike: Pick<Document, "getElementById"> & { documentElement: HTMLElement } = document): HTMLElement {
  return documentLike.getElementById("mobile-console-root")
    ?? documentLike.getElementById("root")
    ?? documentLike.documentElement;
}

export async function installMobileConsole(search = window.location.search): Promise<void> {
  if (!isMobileConsoleEnabled(search)) return;
  if ((window as Window & { __vConsole?: unknown }).__vConsole) return;

  installPromise ??= import("vconsole")
    .then(({ default: VConsole }) => {
      const logBuffer = createMobileConsoleLogBuffer();
      stopLogCapture = captureMobileConsoleLogs(console, logBuffer);
      const vConsole = new VConsole({
        target: resolveMobileConsoleTarget(),
        log: { maxLogNumber: 1000, showTimestamps: true },
      });
      addMobileConsoleExportPlugin(vConsole, logBuffer);
      // Keep a reference for manual inspection and test cleanup.
      (window as Window & { __vConsole?: unknown }).__vConsole = vConsole;
    })
    .catch((cause) => {
      stopLogCapture?.();
      stopLogCapture = null;
      installPromise = null;
      throw cause;
    });
  await installPromise;
}
